import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import {
    analyticsPaymentSetupHelpClickChat,
    analyticsPaymentSetupHelpClickPhone,
    analyticsPaymentSetupHelpClickBack,
} from '@perpay-web/fintech/actions/analytics/paymentSetupHelp';
import PaymentSetupCall from '@perpay-web/fintech/components/composite/PaymentSetupCall/PaymentSetupCall';
import { launchSupportTool } from '@perpay-web/services/supportTool';

const PaymentSetupCallContainer = ({
    onClickBack: ownPropsOnClickBack,
    inModal,
    phoneNumber,
}) => {
    const dispatch = useDispatch();

    const onClickChat = useCallback(() => {
        dispatch(analyticsPaymentSetupHelpClickChat());
        dispatch(launchSupportTool());
    }, [dispatch]);

    const onClickPhone = useCallback(() => {
        dispatch(analyticsPaymentSetupHelpClickPhone());
    }, [dispatch]);

    const onClickBack = useCallback(() => {
        dispatch(analyticsPaymentSetupHelpClickBack());
        ownPropsOnClickBack();
    }, [dispatch, ownPropsOnClickBack]);

    return (
        <PaymentSetupCall
            phoneNumber={phoneNumber}
            inModal={inModal}
            onClickBack={onClickBack}
            onClickChat={onClickChat}
            onClickPhone={onClickPhone}
        />
    );
};

export default PaymentSetupCallContainer;
